// OK - Error CORS
// import axios from "axios";
import Properties from "../properties"
import apiClient from "../plugins/axios-instance";

const API_URL_DEVELOPMENT = "https://api.amigogroup.id/api-merchants/v2/rekap-promo-merchant";
const API_URL_PRODUCTION = "https://backend.amigogroup.net/merchant-api/api/rekap-promo-merchant";


export default class LaporanTukarMerchantServices {
  constructor() { }
  config = this.$session.get("jwt");

  static getURL = () => {
    return Properties.BUILD_TYPE == "production" ? API_URL_PRODUCTION : API_URL_DEVELOPMENT;
  }

  static get = (body) => {
    return apiClient.get(
      this.getURL() + "/",
      {
        params: body,
      },
    );
  }
  static getMerchant = (body) =>
    apiClient.get(
      this.getURL() + "/get-id-merchant",
      {
        params: body,
      },
    );
  static getPromo = (body) =>
    apiClient.get(
      this.getURL() + "/get-id-promo",
      {
        params: body,
      },
    );
  static getRekap = (body) =>
    apiClient.get(
      this.getURL() + "/get-rekap",
      {
        params: body,
      },
    );
  static getKontrak = () =>
    apiClient.get(
      this.getURL() + "/get-kontrak",
      {
      },
    );

}
